(function ($) {

    $.ZagScrollAnimate = function (element, options) {

        var component = element;
        var options = $.extend({}, $.ZagScrollAnimate.defaultOptions, options);
        ZagScrollAnimateSetup(component, options);

    };

    $.fn.ZagScrollAnimate = (function (options) {
        return this.each(function () {
            (new $.ZagScrollAnimate($(this), options));
        });
    });

    $.ZagScrollAnimate.defaultOptions = { offset: 50, targets: [], overflow: false };

    ZagScrollAnimateSetup = function (component, options) {

        options.targets.forEach((target) => {
            count = 0;
            component.find(target.selector).each(function () {
                $(this).attr("data-scroll_animate_type", target.type);
                $(this).attr("data-scroll_animate_stagger", count * target.stagger);
                count++;
            });
        });

        var waypoint = new Waypoint({
            element: component,
            handler: function (direction) {
                ZagScrollAnimateExecute(this.element, direction, options.overflow);
            },
            triggerOnce: true,
            offset: options.offset + '%'
        })
    };

    ZagScrollAnimateExecute = function (waypoint, direction, overflow) {
        if (direction == "down") {

            if (overflow) {
                ZagScrollAnimateOverflow(waypoint);
            }

            waypoint.find("[data-scroll_animate_type]").each(function () {
                var element = $(this);
                var type = $(this).attr("data-scroll_animate_type");
                var stagger = $(this).attr("data-scroll_animate_stagger");

                setTimeout(
                    function (e) {
                        element.addClass("animate__animated");
                        element.addClass(type);
                    }, stagger);

            });
        }
    };

    ZagScrollAnimateOverflow = function (waypoint) {

        // 1000 ms comes from the animate.css's 1 second animation standard
        const animationDuration = 1000;
        const elementsLast = waypoint.find("[data-scroll_animate_type]").last();
        const elementsLastStagger = parseInt(elementsLast.attr("data-scroll_animate_stagger")) + animationDuration;

        waypoint.addClass("zag-scroll-animate-hide-overflow");

        setTimeout(
            function (e) {
                waypoint.removeClass("zag-scroll-animate-hide-overflow");
            }, elementsLastStagger);

    }

})(jQuery);